// eslint-disable-next-line import/prefer-default-export
export const firebaseConfig = {
	apiKey: 'AIzaSyCz2G6yZ6w7vZJXvTdMyoMQzLz9b3DFON0',
	authDomain: 'pruebastackblitz.firebaseapp.com',
	projectId: 'pruebastackblitz',
	storageBucket: 'pruebastackblitz.appspot.com',
	messagingSenderId: '842269827344',
	appId: '1:842269827344:web:427c75f5f38134f3b0c595',
	measurementId: 'G-TKEERMGGWS',
};
